import React from 'react';
import './Banner.css';
import { useTranslation } from 'react-i18next';
import Button from '../../../../components/Buttons/Button/Button';
import Label from '../../../../components/EntToEndUI/Label/Label';
import { useScroll } from '../../../../context/ScrollContext';


const BannerVideo = () => {
  const { t } = useTranslation();
  
  return (
    <section className="main-banner-video">
      <div className="main-banner-container">
        <Label 
          topText={t('videoAboutUs.title')}
          bottomText={t('videoAboutUs.subTitle')}
          shift="medium"
          className="background-video-label"
          />
        <video className="background-video" autoPlay muted loop>
          <source src="/videos/preview.mp4" type="video/mp4" />
          Ваш браузер не поддерживает видео тег.
        </video>
      </div>
    </section>
  );
};

const BannerImage = () => {
  const { t } = useTranslation();
  const { scrollTo } = useScroll();
  
  const handleOrderClick = () => {
    console.log('Нажата кнопка заказа в баннере');
    scrollTo('requestForm');
  };
  
  return (
    <section className="main-banner">
    {/* <video className="background-video" autoPlay muted loop>
      <source src="/videos/preview.mp4" type="video/mp4" />
      Ваш браузер не поддерживает видео тег.
    </video> */}
    <div className="main-banner-container">
      <img className="background-video" src="/images/main_banner.jpeg" alt="Banner" />
      <div className="content-container">
        <div className="text-content">
          {/* <div className="banner-label">{t('main.banner.lable')}</div> */}
          <h1>{t('main.banner.lable')}</h1>
          <div className="subtitle-container">
            <h4>{t('main.banner.subtitle')}</h4>
            <p>{t('main.banner.description')}</p>
          </div>
          <Button 
            text="Оставить заявку" 
            onClick={handleOrderClick} 
            type="calc"
          />
        </div>
      </div>
    </div>
    </section>
  );
};

export {BannerVideo, BannerImage}; 